import React, { Component } from 'react';
import { ResponsiveBar } from '@nivo/bar';



class WidgetChartBar extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      data: props.data ?? [
        {
          "id": "japan",
          "color": "#1DC5C9",
          "data": []
        },
      ],
      key1: props.key1 ?? 'before',
      key2: props.key2 ?? 'after',
      max: props.max ?? 10,
      colors: props.colors ?? global.themeColors,
    };
  }


  static getDerivedStateFromProps(props) {
    return {
      data: props.data ?? [
        {
          "id": "japan",
          "color": "#1DC5C9",
          "data": []
        },
      ],
      key1: props.key1 ?? 'before',
      key2: props.key2 ?? 'after',
      max: props.max ?? 10,
      colors: props.colors ?? global.themeColors,
    }
  }


  renderLight() {
    return (
      <ResponsiveBar
        data={this.state.data}
        keys={[
          this.state.key1,
          this.state.key2,
      ]}
        indexBy="date"
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        padding={0.3}
        groupMode="grouped"
        maxValue={this.state.max}
        minValue={0}
        innerPadding={3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={[global.themeColors[0], global.themeColors[1]]}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        enableLabel={false}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        theme={{
          tooltip: {
            container: {
              background: "#ffffff",
              fontSize: 12
            },
          },
        }}
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={e=>e.id+": "+e.formattedValue+" in country: "+e.indexValue}
      />
    )
  }


  renderDark() {
    return (
      <ResponsiveBar
        data={this.state.data}
        keys={[
          this.state.key1,
          this.state.key2,
        ]}
        indexBy="date"
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        padding={0.3}
        groupMode="grouped"
        minValue={0}
        maxValue={10}
        innerPadding={3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={[global.themeColors[0], global.themeColors[1]]}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        theme={{
          tooltip: {
            container: {
              background: "#ffffff",
              fontSize: 12
            },
          },
        }}
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
        enableGridX={false}
        enableGridY={false}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={e=>e.id+": "+e.formattedValue+" in country: "+e.indexValue}
      />
    )
  }


  render() {
    return (
      <div className="chart">
        <div className="show-light chart">
          {this.renderLight()}
        </div>
        <div className="show-dark chart solid">
          {this.renderDark()}
        </div>
      </div>
    )
  }
}


export default WidgetChartBar;